'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import contentData from '@/lib/constants/content';
import { useCart } from '@/contexts/CartContext';

const linkClass =
  'sr-only rounded bg-white px-4 py-2 text-black focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50';

const SkipLink = ({
  href = '#main-content',
  children = contentData.skipLink.skipToContent['en-us'],
}) => {
  const pathname = usePathname();
  const { cart } = useCart();
  const { skipToCart, skipToCO } = contentData.skipLink;

  // Route-based, not cart-based: hide "Go to cart" on the cart page itself.
  const showCart = pathname !== '/cart';
  // Checkout also needs a live Shopify URL, which is empty until items are added.
  const checkoutUrl = cart?.checkoutUrl;
  const showCheckout = checkoutUrl && cart?.totalQuantity > 0;

  return (
    <>
      {/* Same-page fragment: must stay a native <a>, next/link would intercept
          the navigation and the browser would never move focus to the target. */}
      <a href={href} className={linkClass}>
        {children}
      </a>
      {showCart && (
        <Link href="/cart" className={linkClass}>
          {skipToCart['en-us']}
        </Link>
      )}
      {showCheckout && (
        <a href={checkoutUrl} className={linkClass}>
          {skipToCO['en-us']}
        </a>
      )}
    </>
  );
};

export default SkipLink;
